import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Redirects user to their default landing page based on role.
 * Admin → /dashboard
 * Sales → /quotes
 * Accounting → /cari
 * Warehouse → /products
 * Viewer → /reports/stock
 */
const ROLE_LANDING = {
  admin: "/dashboard",
  sales: "/quotes",
  accounting: "/cari",
  warehouse: "/products",
  viewer: "/reports/stock",
};

export default function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const dest = ROLE_LANDING[user.role] || "/products";
  return <Navigate to={dest} replace />;
}
